import { SelectValue } from '../../../Components/Base/Select/Select';
import { useLazyNcziListDiagnosisItemsQuery } from '../../../graphql/graphql';

export default function useNCZIReference() {
	const [getListDiagnosisItems] = useLazyNcziListDiagnosisItemsQuery();
	const handleSearchDiagnosisItem = async (
		searchInput: string,
		showCode: boolean = false,
	): Promise<SelectValue[]> => {
		const { items: listDiagnosisItems } = await getListDiagnosisItems({
			fulltext: searchInput,
		}).unwrap();

		const items: SelectValue[] = [];

		for (const listEnumItem of listDiagnosisItems?.data || []) {
			if (listEnumItem && listEnumItem.code) {
				items.push({
					label:
						(showCode ? listEnumItem.code + ' - ' : '') +
						(listEnumItem.name || ''),
					value: {
						displayName: listEnumItem.name || '',
						code: listEnumItem.ncziCode,
						scheme: {
							oid: listEnumItem.enum?.oid || '',
							version: listEnumItem.enum?.version || '',
						},
					},
				});
			}
		}
		return items;
	};

	return {
		handleSearchDiagnosisItem,
	};
}
